var _defs, _rect, _g, _rect2, _text, _rect3, _text2, _rect4, _text3, _line, _text4, _line2, _text5, _line3, _text6, _line4, _text7, _line5, _text8, _g2, _g3, _text9, _text10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassportCaptureGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 280,
    viewBox: "0 0 400 280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mrzPulse",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 2,
    floodColor: "rgba(242,164,11,0.7)",
    floodOpacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stdDeviation",
    dur: "1.2s",
    values: "3;8;3",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "flood-opacity",
    dur: "1.2s",
    values: "3;8;3",
    repeatCount: "indefinite"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 280,
    fill: "none",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 3,
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 10 L 10 30 M 10 10 L 30 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 390 10 L 370 10 M 390 10 L 390 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 270 L 30 270 M 10 270 L 10 250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 390 270 L 390 250 M 390 270 L 370 270"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 360,
    height: 35,
    fill: "none",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 40,
    textAnchor: "middle",
    fill: "rgba(255,255,255,0.9)",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "PASSPORT HEADER")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 70,
    width: 80,
    height: 100,
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 125,
    textAnchor: "middle",
    fill: "rgba(255,255,255,0.9)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "PHOTO")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 260,
    height: 140,
    fill: "none",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1,
    strokeDasharray: "2,2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 85,
    textAnchor: "middle",
    fill: "rgba(255,255,255,0.9)",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "PERSONAL INFORMATION")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 95,
    x2: 370,
    y2: 95,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 105,
    fill: "rgba(255,255,255,0.8)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Surname\n    / Given Names")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 115,
    x2: 370,
    y2: 115,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 125,
    fill: "rgba(255,255,255,0.8)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "\n    Nationality")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 135,
    x2: 370,
    y2: 135,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 145,
    fill: "rgba(255,255,255,0.8)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Date\n    of Birth")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 155,
    x2: 370,
    y2: 155,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 165,
    fill: "rgba(255,255,255,0.8)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Place\n    of Birth")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 175,
    x2: 370,
    y2: 175,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 185,
    fill: "rgba(255,255,255,0.8)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Date\n    of Issue / Expiry")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#mrzPulse)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 220,
    width: 360,
    height: 45,
    fill: "none",
    stroke: "rgba(242,164,11,0.7)",
    strokeWidth: 2.5,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 235,
    textAnchor: "middle",
    fill: "rgba(242,164,11,0.9)",
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    fontSize: 9
  }, "MACHINE READABLE ZONE (MRZ)"), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 245,
    x2: 370,
    y2: 245,
    stroke: "rgba(242,164,11,0.5)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 255,
    x2: 370,
    y2: 255,
    stroke: "rgba(242,164,11,0.5)",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 1,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 130,
    x2: 200,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 140,
    x2: 210,
    y2: 140
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 140,
    r: 8,
    fill: "none",
    strokeWidth: 1
  }))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 15,
    textAnchor: "middle",
    fill: "rgba(255,255,255,1.0)",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: "bold"
  }, "Passport Alignment Guide")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 275,
    textAnchor: "middle",
    fill: "rgba(255,255,255,0.9)",
    fontFamily: "Arial, sans-serif",
    fontSize: 8
  }, "Align your passport within this guide")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportCaptureGuide);
export default __webpack_public_path__ + "static/media/passport-capture-guide.c3450bcafff6da1a4b459b5bad303384.svg";
export { ForwardRef as ReactComponent };